import { tns } from 'tiny-slider'

export function setupSlider(slider) {

    const container = slider.querySelector('.slider');
    const controlsContainer = slider.querySelector('.slider__controls')
    const navContainer = slider.querySelector('.slider__navigation')

    if (!container) {
        throw 'container is required for the slider to function correctly.'
    }

    const timeout = slider.dataset['timeout']
    const autoplay = (timeout > 0)

    tns({
        container,
        controlsContainer,
        navContainer,
        autoplayHoverPause: true,
        autoplay,
        autoplayTimeout: timeout,
        autoplayButtonOutput: false
    })
}


export function setupSliders() {

    const containers = document.querySelectorAll('.slider-wrapper')

    containers.forEach(setupSlider)

}
